/**
 * Shared integration copy contract. Both Admin and the desktop renderer resolve
 * these keys through the same client-app translation catalog.
 */
const INTEGRATION_DESCRIPTION_TRANSLATION_KEYS: Readonly<
  Record<string, string>
> = {
  "Custom MCP": "website.integrationsSettings.toolDescriptions.customMcp",
  Shopify: "website.integrationsSettings.toolDescriptions.shopify",
  BigCommerce: "website.integrationsSettings.toolDescriptions.bigCommerce",
  WooCommerce: "website.integrationsSettings.toolDescriptions.wooCommerce",
  Magento: "website.integrationsSettings.toolDescriptions.magento",
  PrestaShop: "website.integrationsSettings.toolDescriptions.prestashop",
  Wix: "website.integrationsSettings.toolDescriptions.wix",
  "Google Ads": "website.integrationsSettings.toolDescriptions.googleAds",
  "TikTok Ads": "website.integrationsSettings.toolDescriptions.tikTokAds",
  "Meta Ads": "website.integrationsSettings.toolDescriptions.metaAds",
  "LinkedIn Ads": "website.integrationsSettings.toolDescriptions.linkedInAds",
  "Pinterest Ads": "website.integrationsSettings.toolDescriptions.pinterestAds",
  "X Ads": "website.integrationsSettings.toolDescriptions.xAds",
  YouTube: "website.integrationsSettings.toolDescriptions.youtubeAds",
  "YouTube Ads": "website.integrationsSettings.toolDescriptions.youtubeAds",
  "Snapchat Ads": "website.integrationsSettings.toolDescriptions.snapchatAds",
  "Google Search Console":
    "website.integrationsSettings.toolDescriptions.googleSearchConsole",
  "Google Analytics":
    "website.integrationsSettings.toolDescriptions.googleAnalytics",
  Klaviyo: "website.integrationsSettings.toolDescriptions.klaviyo",
  Mailchimp: "website.integrationsSettings.toolDescriptions.mailchimp",
  Omnisend: "website.integrationsSettings.toolDescriptions.omnisend",
  Okendo: "website.integrationsSettings.toolDescriptions.okendo",
  GoAffPro: "website.integrationsSettings.toolDescriptions.goaffpro",
  UpPromote: "website.integrationsSettings.toolDescriptions.uppromote",
  Loox: "website.integrationsSettings.toolDescriptions.loox",
  TrustWILL: "website.integrationsSettings.toolDescriptions.trustwill",
  NoxInfluencer: "website.integrationsSettings.toolDescriptions.noxinfluencer",
  "Insider One": "website.integrationsSettings.toolDescriptions.insiderOne",
  Emarsys: "website.integrationsSettings.toolDescriptions.emarsys",
  "Judge.me": "website.integrationsSettings.toolDescriptions.judgeme",
  "Facebook Page": "website.integrationsSettings.toolDescriptions.facebookPage",
  Instagram: "website.integrationsSettings.toolDescriptions.instagram",
  Feishu: "website.integrationsSettings.toolDescriptions.feishu",
  DingTalk: "website.integrationsSettings.toolDescriptions.dingtalk",
  Figma: "website.integrationsSettings.toolDescriptions.figma",
  Slack: "website.integrationsSettings.toolDescriptions.slack",
  Semrush: "website.integrationsSettings.toolDescriptions.semrush",
  Similarweb: "website.integrationsSettings.toolDescriptions.similarweb",
  Ahrefs: "website.integrationsSettings.toolDescriptions.ahrefs",
  AliExpress: "website.integrationsSettings.toolDescriptions.aliexpress",
  Aliexpress: "website.integrationsSettings.toolDescriptions.aliexpress",
  Squarespace: "website.integrationsSettings.toolDescriptions.squarespace",
};

export function getIntegrationDescriptionTranslationKey(
  tool: string,
): string | undefined {
  return INTEGRATION_DESCRIPTION_TRANSLATION_KEYS[tool];
}
